export default "__VITE_ASSET__DPqIvoR5__"